import { render } from "./SocialView.vue?vue&type=template&id=efc7a424&ts=true"
import script from "./SocialView.vue?vue&type=script&lang=ts"
export * from "./SocialView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__